export default "__VITE_ASSET__f2206931__"